import { render, staticRenderFns } from "./RepCard.vue?vue&type=template&id=27c1be8b"
import script from "./RepCard.vue?vue&type=script&lang=js"
export * from "./RepCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports